import { connect } from 'react-redux';

const mapStateToProps = ({ acls }) => ({
  scopes: acls.scopes
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps);
